<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(items,index) in breadcrumb.list" :key="index">
        <span>{{items.name}}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <h1>{{breadcrumb.title}}</h1>
  </div>
</template>
<script>
export default {
  props: {
    breadcrumb: Object,
    // //  breadcrumb: {
    //     title: "Order Query",
    //     list: [
    //       {
    //         name: "Report",
    //       },
    //       {
    //         name: "Waybill/Orders",
    //       },
    //     ],
    //   },
  },
  data() {
    return {};
  },
};
</script>
<style scoped lang="scss">
h1 {
  margin: 20px 0;
}
span {
  font-size: $sbuTitle;
}
</style>